export const GEARS_EQS_ADD: number[][] = [
  [2, 2, 4],
  [2, 3, 5],
  [2, 4, 6],
  [2, 5, 7],
  [2, 6, 8],
  [2, 7, 9],
  [2, 8, 10],
  [3, 3, 6],
  [3, 4, 7],
  [3, 5, 8],
  [3, 6, 9],
  [3, 7, 10],
  [4, 4, 8],
  [4, 5, 9],
  [4, 6, 10],
  [5, 5, 10],
];

export const GEARS_EQS_MUL: number[][] = [
  [2, 2, 4],
  [2, 3, 6],
  [2, 4, 8],
  [2, 5, 10],
  [2, 6, 12],
  [2, 7, 14],
  [2, 8, 16],
  [2, 9, 18],
  [3, 3, 9],
  [3, 4, 12],
  [3, 5, 15],
  [3, 6, 18],
  [3, 7, 21],
  [3, 8, 24],
  [3, 9, 27],
  [4, 4, 16],
  [4, 5, 20],
  [4, 6, 24],
  [4, 7, 28],
  [4, 8, 32],
  [4, 9, 36],
];

export const GEARS_EQS_MULDIV_EXT: number[][] = [
  [2, 2, 4],
  [2, 3, 6],
  [2, 4, 8],
  [2, 5, 10],
  [2, 6, 12],
  [2, 7, 14],
  [2, 8, 16],
  [2, 9, 18],
  [3, 3, 9],
  [3, 4, 12],
  [3, 5, 15],
  [3, 6, 18],
  [3, 7, 21],
  [3, 8, 24],
  [3, 9, 27],
  [4, 4, 16],
  [4, 5, 20],
  [4, 6, 24],
  [4, 7, 28],
  [4, 8, 32],
  [4, 9, 36],
  [5, 5, 25],
  [5, 6, 30],
  [5, 7, 35],
  [5, 8, 40],
  [5, 9, 45],
  [6, 6, 36],
  [6, 7, 42],
  [6, 8, 48],
  [6, 9, 54],
  [7, 7, 49],
  [7, 8, 56],
  [7, 9, 63],
  [8, 8, 64],
  [8, 9, 72],
  [9, 9, 81],
];
